<template>
  <div>
    <div class="-mx-2">
      <carousel
        :per-page="$isMobile.value ? 1 : 3"
        :autoplay="true"
        :pagination-enabled="false"
        :autoplay-timeout="5000"
      >
        <slide
          v-for="search in searches"
          :key="'search' + search.name"
          class="px-2"
        >
          <div
            id="quickSearch"
            v-local-img-bg="
              `linear-gradient(rgba(8,11,5,0.3),rgba(31,47,21,0.5)), url(quickSearches/${search.image})`
            "
            class="brand-heading flex h-28 w-full cursor-pointer select-none items-center justify-center rounded-lg border bg-cover bg-center uppercase text-gray-300 transition-all duration-200 hover:text-white md:h-32"
            :class="
              selectedSearch !== null && search.name === selectedSearch.name
                ? 'quickSearchSelected text-white'
                : ''
            "
            @click="searchSelect(search)"
          >
            <div>
              {{ search.name }}
              <div
                class="mx-auto h-1 rounded-lg bg-brand-500 opacity-90 transition-all duration-500"
                :class="
                  selectedSearch !== null && search.name === selectedSearch.name ? 'w-full' : 'w-0'
                "
              />
            </div>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  components: {
    Carousel,
    Slide,
  },

  props: {
    sortBy: {
      type: String,
      default: '0',
    },
  },

  data() {
    return {
      selectedSearch: null,
    };
  },

  computed: {
    searches() {
      const array = [
        { name: this.$t('explore.clubList.favourites'), image: 'favourites.jpg', sortBy: '4' },
        { name: 'Recently Played', image: 'recentlyplayed.jpg', sortBy: '5' },
        { name: 'Most Visited', image: 'nearby.jpg', sortBy: '6' },
      ];

      // Otherwise it would be an odd amount on desktop, must be a multiple of 3
      if (this.$isMobile.value) {
        array.push({ name: 'New Clubs', image: 'newclubs.jpg', sortBy: '7' });
      }

      return array;
    },
  },

  watch: {
    sortBy() {
      if (this.selectedSearch !== null && this.sortBy !== this.selectedSearch.sortBy) {
        this.selectedSearch = null;
      }
    },
  },

  methods: {
    searchSelect(search) {
      this.selectedSearch = search;
      this.$emit('search', {
        sortBy: search.sortBy,
      });
    },
  },
};
</script>

<style>
.quickSearchSelected {
  color: rgb(255, 255, 255) !important;
  padding-bottom: 7px;
}
#quickSearch:hover {
  padding-bottom: 7px;
}
</style>
